/**
 * Load More Related Articles Module
 */
export function initLoadMoreRelatedArticles() {
  (function ($) {
    "use strict";

    // 1. Selectors
    const $grid = $("#related-articles-grid");
    const $loadMoreBtn = $("#load-more-related");
    const $paginationWrapper = $loadMoreBtn.parent(); // .related-articles__pagination

    // Guard Clause: Exit if elements don't exist
    if (!$grid.length || !$loadMoreBtn.length) return;

    // 2. State & Data
    let currentPage = 1;
    // Parse Ints to ensure data integrity
    const categoryId = parseInt($grid.data("category-id")) || 0;
    const currentPostId = parseInt($grid.data("post-id")) || 0;
    // We fetch max pages from the data attribute we added in PHP
    const maxPages = parseInt($grid.data("max-pages")) || 1;

    let isLoading = false;

    // 3. Event Listener
    $loadMoreBtn.on("click", function (e) {
      e.preventDefault();

      if (isLoading || currentPage >= maxPages) return;

      fetchRelatedArticles();
    });

    // 4. Fetch Logic
    function fetchRelatedArticles() {
      isLoading = true;
      const nextPage = currentPage + 1;

      // UI: Loading State
      $loadMoreBtn.addClass("btn--loading").prop("disabled", true);
      const originalText = $loadMoreBtn.find(".btn__text").text();
      $loadMoreBtn.find(".btn__text").text("Loading...");

      $.ajax({
        url: ducon_ajax.ajaxUrl, // Matches functions.php localization
        type: "POST",
        dataType: "json",
        data: {
          action: "load_more_related_articles",
          nonce: ducon_ajax.nonce,
          page: nextPage,
          category_id: categoryId,
          current_post: currentPostId,
        },
        success: function (response) {
          if (response.success && response.data.content) {
            // Append Content
            $grid.append(response.data.content);

            // Update State
            currentPage = nextPage;

            // Refresh Animations (Important for AOS to see new elements)
            if (typeof window.AOS !== "undefined") {
              window.AOS.refresh();
            }

            // Restore Button
            $loadMoreBtn.removeClass("btn--loading").prop("disabled", false);
            $loadMoreBtn.find(".btn__text").text(originalText);

            // Check if we reached the end
            if (currentPage >= response.data.max) {
              handleEndOfPosts();
            }
          } else {
            // If success is false or content empty
            handleEndOfPosts();
          }
        },
        error: function (xhr, status, error) {
          console.error("Ducon Error:", error);
          // Restore button state on error so user can try again
          $loadMoreBtn.removeClass("btn--loading").prop("disabled", false);
          $loadMoreBtn.find(".btn__text").text(originalText);
        },
        complete: function () {
          isLoading = false;
        },
      });
    }

    /**
     * Helper: Handle "No More Posts" UI
     */
    function handleEndOfPosts() {
      $loadMoreBtn.hide(); // Fade out or hide button

      // Remove any existing messages first
      $paginationWrapper.find(".related-articles__message").remove();

      // Append BEM styled message
      $paginationWrapper.append(
        '<p class="related-articles__message">No more related articles to show.</p>',
      );
    }
  })(jQuery);
}
